import React from 'react'
import { motion } from "framer-motion"
export default function Certificate(props) {
  return (
   
    <div className="modal-container active" data-modal-container="">
              <div className="overlay" data-overlay="" />
              <motion.div 
    
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1,delay:0 }} >
              <section className="testimonials-modal">
                <button className="modal-close-btn" data-modal-close-btn="" onClick={()=>{
                   props.setshow({
                    isShow: false,
                    cretificateName : "",
                    cretificateDescripton : "",
                    certificateImageSrc : "",
                    cretificateLink : ""
                   })
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"/></svg>
                </button>
                 
                <div>
                <img src={props.cerImageSrc} alt="nodejs" height={5} width={500} />
                <a href={props.cerLink} target="_blank"  rel="noreferrer" className='text-white mt-[20px] ml-[32px] font-bold sm:ml-[100px]'>
                    See certificate
                </a>
                </div>
                
                
                <div className="modal-content ">
                  <h4 className="h3 modal-title" data-modal-title="">
                    {props.cerName}
                  </h4>
                  <time dateTime="2024-06-15">{props.cerDate}</time>
                  <div data-modal-text="">
                    <p>
                    {props.cerDescription}
                    </p>
                  </div>
                </div>
                
              </section>
              </motion.div>
            </div>
            
  )
}
